const LOAD_NOTIFICATION           = 'LOAD_NOTIFICATION'
const LOAD_NOTIFICATION_SUCCESS   = 'LOAD_NOTIFICATION_SUCCESS'
const LOAD_NOTIFICATION_FAILED    = 'LOAD_NOTIFICATION_FAILED'
const UNMOUNT_NOTIFICATION        = 'UNMOUNT_NOTIFICATION'
const initialState = {
  loading: true,
  data: null,
  message: null,
}
const notificationReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_NOTIFICATION:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_NOTIFICATION_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_NOTIFICATION_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_NOTIFICATION:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}
export default notificationReducer;